// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { menuTippyStyles } from "@west/App/Components/Tippy/MenuTippy";
import { css } from "styled-components";

menuTippyStyles.container = {
    css: css`
        &&&.tippy-box {
            &[data-placement^="bottom"] > .tippy-arrow {
                top: -24px;
                left: 38px !important;
                &:before {
                    transform: scale(0.8, 0.8) rotate(-135deg);
                }
            }
        }
    `,
};
